import { SortDirection } from '../types/sort-direction';

export class SelectedSort {
    ColumnName = '';
    DefaultColumn = '';
    SortDirection = SortDirection.Ascending;

    constructor(selectedSort?) {
        if (selectedSort) {
            this.Initialize(selectedSort);
        }
    }

    Initialize(selectedSort) {
        this.ColumnName = selectedSort.ColumnName;
        this.SortDirection = selectedSort.SortDirection;
    }
}
